 import React, { Fragment, useState, useEffect, useRef } from "react";
import { Button, Modal } from "react-bootstrap";
import PageTitle from "../../layouts/PageTitle";
import { useParams } from "react-router-dom";
import { QRCodeCanvas } from "qrcode.react";
import axios from "axios";
import swal from "sweetalert";

const Checkout = () => {
  const { id } = useParams();
  const [deposit, setDeposit] = useState([]);
  const [copied, setCopied] = useState(false);
  const [depositInput, setDepositInput] = useState({ amount: '', error_list: [] });
  const [showModal, setShowModal] = useState(false);
  const [income, setIncome] = useState([]);
  const [loading, setLoading] = useState(false);
  const [url, setUrl] = useState("");
  const qrRef = useRef();

  useEffect(() => {
    const data = {
      key_s: 'eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9',
      payment_id: id,
    };
    axios.post('/apps-deposit-get', data)
      .then(response => setDeposit(response.data.data))
      .catch(error => console.log(error));
  }, [id]);

  const handleInput = (e) => {
    setDepositInput({ ...depositInput, [e.target.name]: e.target.value });
  };

  const depositSubmit = (e) => {
    e.preventDefault();
    const auth_token = localStorage.getItem('auth_token');
    const data = {
      amount: depositInput.amount,
      key_s: 'eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9',
      gateway_id: id,
    };
    if (auth_token && !loading) {
      setLoading(true);
      axios.post(`/apps-deposit-sub`, data).then(res => {
        setLoading(false);
        if (res.data.status === 'success') {
          setIncome(res.data.data.original);
          setShowModal(res.data.data.original);
          swal("Success", res.status, "success");
          setDepositInput({ amount: '', error_list: [] });
        } else if (res.data.status === 'fail') {
          swal("Warning", res.data.message, "warning");
        } else {
          setDepositInput({ ...depositInput, error_list: res.data.validation_error });
        }
      });
    }
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const handleTextClick = () => {
    const textToCopy = showModal.sendto;
    navigator.clipboard.writeText(textToCopy)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 3000);
      })
      .catch((error) => console.error('Unable to copy text: ', error));
  };

  const downloadQRCode = (e) => {
    e.preventDefault();
    let canvas = qrRef.current.querySelector("canvas");
    let image = canvas.toDataURL("image/png");
    let anchor = document.createElement("a");
    anchor.href = image;
    anchor.download = `qr-code.png`;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    setUrl("");
  };

  const qrcode = (
    <QRCodeCanvas
      id="qrCode"
      value={showModal.sendto}
      size={200}
      bgColor={"#ffffff"}
      level={"H"}
    />
  );

  return (
    <Fragment>
      <div className="container py-4">
        <div className="row">
          <Modal show={showModal} onHide={closeModal} centered>
            <Modal.Header closeButton>
              <Modal.Title>Crypto Payment</Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-center">
              <h5>{showModal.currency}</h5>
              <h5>Total Amount: {showModal.amount}</h5>
              <h6 onClick={handleTextClick} style={{ cursor: 'pointer', color: "#0d6efd" }}>
                {showModal.sendto}
              </h6>
              {copied && <p className="text-success">Address copied!</p>}

              <div ref={qrRef} className="bg-light p-3 my-3 d-inline-block">
                {qrcode}
              </div>
              <div>
                <form onSubmit={downloadQRCode}>
                  <Button type="submit" variant="outline-primary" size="sm">Download QR</Button>
                </form>
              </div>
              <img src={showModal.img} alt="" className="img-fluid rounded mt-3" width={150} />
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={closeModal}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>

          <div className="col-lg-4 mb-4">
            <div className="card shadow-sm h-100">
              <div className="card-body">
                <h5 className="card-title text-center mb-4">Deposit Info</h5>
                <ul className="list-group list-group-flush">
                  <li className="list-group-item">
                    <strong>Payment:</strong> {deposit.Payment_name}
                  </li>
                  <li className="list-group-item">
                    <strong>Time Limit:</strong> 30 Minutes
                  </li>
                  <li className="list-group-item">
                    <strong>Deposit Limit:</strong><br />
                    Min: {deposit.currency_name} {deposit.min_amount}<br />
                    Max: {deposit.currency_name} {deposit.max_amount}
                  </li>
                  <li className="list-group-item">
                    <strong>Details:</strong> {deposit.Payment_details}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="col-lg-8">
            <div className="card shadow-sm">
              <div className="card-body">
                <h4 className="mb-4">Deposit Balance</h4>
                <form onSubmit={depositSubmit}>
                  <div className="mb-3">
                    <label htmlFor="amount" className="form-label">Amount</label>
                    <input
                      type="text"
                      className="form-control"
                      id="amount"
                      name="amount"
                      value={depositInput.amount}
                      onChange={handleInput}
                      placeholder={`Enter ${deposit.currency_name} Amount (${deposit.currency_symbols})`}
                      required
                    />
                    {depositInput.error_list.amount && (
                      <small className="text-danger">{depositInput.error_list.amount}</small>
                    )}
                  </div>

                  <div className="form-check mb-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="terms"
                      required
                    />
                    <label className="form-check-label" htmlFor="terms">
                      Accept Terms & Conditions
                    </label>
                  </div>

                  <Button
                    type="submit"
                    variant="success"
                    size="lg"
                    className="w-100"
                    disabled={loading}
                  >
                    {loading ? "Processing..." : "Continue to Deposit"}
                  </Button>
                </form>
              </div>
            </div>
          </div>

        </div>
      </div>
    </Fragment>
  );
};

export default Checkout;
